import type { GridCell, GridCoord } from '../../types/core';
import { cellKey, isInside, neighbours, uniqueCoords } from '../../utils/grid';

export function roadsAroundBlock(block: readonly GridCoord[], size: number): GridCoord[] {
  const blockKeys = new Set(block.map(cellKey));
  const roadCandidates: GridCoord[] = [];

  for (const coord of block) {
    for (const adjacent of neighbours(coord)) {
      if (isInside(adjacent, size) && !blockKeys.has(cellKey(adjacent))) {
        roadCandidates.push(adjacent);
      }
    }
  }

  return uniqueCoords(roadCandidates);
}

export function isRoadEdge(coord: GridCoord, size: number): boolean {
  return coord.x === 0 || coord.z === 0 || coord.x === size - 1 || coord.z === size - 1;
}

export function withRoads(cells: readonly GridCell[], roads: readonly GridCoord[], size: number): GridCell[] {
  const roadKeys = new Set(roads.map(cellKey));

  return cells.map((cell) => {
    if (!roadKeys.has(cell.key) || cell.buildingId) {
      return cell;
    }

    return {
      ...cell,
      road: true,
      roadEdge: isRoadEdge(cell.coord, size)
    };
  });
}

export function connectedRoadCells(cells: readonly GridCell[]): GridCoord[] {
  return cells.filter((cell) => cell.road).map((cell) => cell.coord);
}
